module.exports = __webpack_public_path__ + "img/پارچه-ای-مدل-کبریتی--طوسی.f8fb918e.png";